import {
  GENERAL_SETTING_FETCH_REQUEST,
  GENERAL_SETTING_FETCH_REQUEST_SUCCESS,
  GENERAL_SETTING_FETCH_REQUEST_FAILURE,
  GENERAL_SETTING_UPDATE_REQUEST,
  GENERAL_SETTING_UPDATE_REQUEST_SUCCESS,
  GENERAL_SETTING_UPDATE_REQUEST_FAILURE,
  GENERAL_SETTING_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const generalSettingsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case GENERAL_SETTING_FETCH_REQUEST:
    case GENERAL_SETTING_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case GENERAL_SETTING_FETCH_REQUEST_SUCCESS:
    case GENERAL_SETTING_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case GENERAL_SETTING_FETCH_REQUEST_FAILURE:
    case GENERAL_SETTING_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case GENERAL_SETTING_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default generalSettingsReducer;
